import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      navigate("/login");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#090D16] px-6" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <div className="w-full max-w-sm">
        <h2 className="text-2xl font-bold tracking-tight text-slate-50" style={{ fontFamily: "Outfit, sans-serif" }}>Choose a new password</h2>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
          <Input data-testid="reset-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="New password" required minLength={6}
            className="border-slate-700 bg-[#111827] text-slate-100 placeholder:text-slate-600 focus-visible:ring-orange-500" />
          <Input data-testid="reset-confirm-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
            placeholder="Confirm password" required minLength={6}
            className="border-slate-700 bg-[#111827] text-slate-100 placeholder:text-slate-600 focus-visible:ring-orange-500" />
          {error && <p data-testid="reset-error" className="text-xs text-rose-400">{error}</p>}
          <Button data-testid="reset-submit-btn" disabled={busy} className="w-full bg-orange-500 font-semibold text-white hover:bg-orange-600">
            {busy ? "Updating…" : "Update password"}
          </Button>
          <Link to="/login" className="block text-center text-xs text-slate-500 hover:text-slate-300">Back to sign in</Link>
        </form>
      </div>
    </div>
  );
}
